import { z } from 'zod';

export const $CandidateNamedReference = z.object({
  id: z.number(),
  name: z.string(),
  slug: z.string(),
});
